import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { backend, eventBackend } from "../../services";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { AddUserModalProps, EventFullData, UserShortInfo } from "../../types";
import { taskUserStatusNames } from "../../constants";
import { RootState } from "../../state/reducer";

const TaskAddUserModal: React.FC<AddUserModalProps> = ({
  task_id,
  def_status_id,
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const groupList = State.groupsToSelect;
  const rights = State.rights;
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );
  const [selectedStatus, setSelectedStatus] = useState<number>(
    def_status_id || 2
  );
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null); // Выбранный пользователь
  const [comment, setComment] = useState<string | undefined>(); // Комментарий
  const modalRef = useRef<HTMLDivElement>(null); // Ref для модального окна
  const [availableUsers, setAvailableUsers] = useState<UserShortInfo[]>([]);

  useEffect(() => {
    backend
      .getAllUsersShorts({ group_id: selectedGroup })
      .then((res) => {
        setAvailableUsers(res.users);
      })
      .catch((err) => {
        console.log(err);
        toast("Не удалось загрузить список пользователей");
      });
  }, [groupList, selectedGroup]);

  // Обработчик выбора пользователя
  const handleUserSelect = (userId: number) => {
    setSelectedUserId(userId);
  };

  // Закрытие модального окна с сохранением
  const closeWithSave = () => {
    if (!task_id) return;
    if (!selectedUserId) {
      toast("Выберите пользователя");
      return;
    }
    /* if (!comment) {
      toast("Комментарий обязателен");
      return;
    } */
    onSave(selectedUserId, selectedStatus, comment || '', task_id); // Вызываем коллбэк с выбранным ID пользователя
    closeModal(); // Закрываем модальное окно
  };

  // Обработчик клика за пределами модального окна
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal(); // Закрываем модальное окно
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModal]);

  return (
    <div className="editModal" ref={modalRef}>
      <div className="modalHeading">
        <h3>Добавить пользователя</h3>
      </div>
      <div className="columnCenter creationForm">
        <div className="formField">
          <label htmlFor="status_id">Статус:</label>
          <select
            id="selectType"
            name="status_id"
            value={selectedStatus}
            onChange={(event) => setSelectedStatus(Number(event.target.value))}
          >
            {taskUserStatusNames.map((item, index) => {
              return (
                <option key={`ts${index}`} value={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="flex formRow">
          <div className="fieldName">Группа</div>
          <div className="fieldInput flex">
            <select
              id="group_id"
              name="group_id"
              value={selectedGroup}
              onChange={(event) => {
                const group = Number(event.target.value);
                setSelectedGroup(group);
              }}
            >
              <option value="0">Любая</option>
              {groupList.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="formField flex formRow">
          <label htmlFor="user">Пользователь</label>
          <ManShortSelector
            items={availableUsers}
            onChangeCallback={handleUserSelect}
            defaultSelectedId={selectedUserId || undefined}
          />
        </div>
        <div className="formField formRow commentRow">
          <label htmlFor="description">Комментарий</label>
          <textarea
            id="description"
            name="description"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
      </div>
      <div className="flex between btnRow">
        <button className="filterButton" type="button" onClick={closeWithSave}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default TaskAddUserModal;
